<template lang="pug">
.generic-wrapper#rent-object-scroll
  .container(v-if="rentObjectType || rentObject")
    BackButton(name="DataRentObjects")
    template(v-if="$route.name === 'DataRentObjectNew'")
      h1.title
        b-icon(:icon="rentObjectType.icon")
        |  Neue/s {{rentObjectType.name}}
      .sub-headline Bitte füllen Sie alle erforderlichen Felder aus.
    template(v-if="$route.name === 'DataRentObjectEdit'")
      h1.title {{formData.name}}
      .sub-headline Mietobjekt mit dem Code: {{formData.code}}

    .tabs-wrapper.margin-top
      b-tabs(type="is-boxed" vertical :animated="false")
        b-tab-item(label="Stammdaten" icon="text-box-outline")
          .fit-content
            .card
              .top
                ValidationObserver(v-slot="{ handleSubmit }")
                  .form.w400
                    ValidationProvider(name="Sichtbar auf Webseite" rules="" v-slot="{ errors, valid }")
                      b-field(:type="{ 'is-danger': errors[0] }" :message="errors")
                        b-switch(v-model="formData.activeWebsite" type="is-success") Sichtbar auf Webseite
                    ValidationProvider(name="Sichtbar im Buchungskalender" rules="" v-slot="{ errors, valid }")
                      b-field(:type="{ 'is-danger': errors[0] }" :message="errors")
                        b-switch(v-model="formData.activeAdmin" type="is-success") Sichtbar im Buchungskalender
                  template(v-for="block, idx in rentObjectType.layout")
                    template(v-if="block.type === 'headline'")
                      h2.title.is-6 {{block.value}}

                    template(v-else)
                      template(v-if="block.value.length === 1")
                        template(v-if="block.value[0].dbName === 'longDescription' || block.value[0].dbName === 'shortDescription' || block.value[0].dbName === 'contractDescription'")
                          component(:is="`${block.value[0].dbName}Field`" v-model="formData[block.value[0].dbName]")
                        .form.w400(v-else)
                          template(v-for="value in block.value")
                            component(:is="`${value.dbName}Field`" v-model="formData[value.dbName]")
                      
                      .form.w400(v-else)
                        b-field(grouped expanded)
                          template(v-for="value, vidx in block.value")
                            component(:is="`${value.dbName}Field`" v-model="formData[value.dbName]")
                            .spacer.sm(v-if="vidx !== block.value.length-1")
                  .spacer.sm
                  b-field(label="Anreise E-Mail Vorlage" label-position="on-border")
                    b-select(v-model="formData.emailTemplateId")
                      option(:value="null") Vom Haupthaus (wenn vorhanden) übernehmen
                      option(v-for="emailTemplate in emailTemplates" :value="emailTemplate.id") {{emailTemplate.subject}}
                  RouterLink(to="/settings/email-templates" target="_blank") E-Mail Vorlagen öffnen

                  .button-wrapper.margin-top.right
                    b-button(type="is-light" @click="$router.push({name: 'DataRentObjects'})") Abbrechen
                    b-button(type="is-primary" @click="handleSubmit(saveRentObject)") Speichern

        b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="Betten" icon="bed-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectBeds(:id="id" :rentObjectType="rentObjectType" :bedrooms="parseInt(formData.bedrooms)")
        b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="Ausstattung" icon="television" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectFeatures(:id="id" :rentObjectType="rentObjectType")
        b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="Extras" icon="star-circle-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectBookingExtras(:id="id" :rentObjectType="rentObjectType")
        b-tab-item(v-if="rentObjectType.name !== 'Haupthaus'" label="Preise" icon="currency-eur" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectPrices(:id="id" :rentObjectType="rentObjectType" :maxPersons="formData.persons")
        b-tab-item(label="Objektbilder" icon="image-multiple-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectAssetManager(:id="id")
        b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="Grundrissbilder" icon="image-multiple-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            GroundplanAssetManager(:id="id")
        b-tab-item(v-if="rentObjectType.name !== 'Stellplatz'" label="Standortbild" icon="map-marker-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectLocation(v-if="formData && formData.id" :marker="{lat: formData.latitude, lng: formData.longitude}" :id="id" :parentId="formData.parentId")
        b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="Bewertungen" icon="star-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            RentObjectRatings(:id="id")
        //- b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="Channels" icon="share-variant" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            .title to doooo
        //- b-tab-item(v-if="rentObjectType.name !== 'Haupthaus' && rentObjectType.name !== 'Stellplatz'" label="PDF Inhalte" icon="file-pdf-outline" :disabled="$route.name === 'DataRentObjectNew'")
          .fit-content
            .title to doooo
</template>

<script>
import RentObjectPrices from "@/components/organisms/RentObjectPrices.vue";
import RentObjectFeatures from "@/components/organisms/RentObjectFeatures.vue";
import RentObjectAssetManager from "@/components/organisms/RentObjectAssetManager.vue";
import GroundplanAssetManager from "@/components/organisms/GroundplanAssetManager.vue";
import RentObjectBookingExtras from "@/components/organisms/RentObjectBookingExtras.vue";
import RentObjectBeds from "@/components/organisms/RentObjectBeds.vue";
import RentObjectRatings from "@/components/organisms/RentObjectRatings.vue";
import RentObjectLocation from "@/components/organisms/RentObjectLocation.vue";

export default {
  components: {
    RentObjectPrices,
    RentObjectAssetManager,
    GroundplanAssetManager,
    RentObjectFeatures,
    RentObjectBookingExtras,
    RentObjectBeds,
    RentObjectRatings,
    RentObjectLocation
  },
  props: {
    rentObjectTypeId: {
      type: [String, Number]
    },
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      },
      formData: {
        rentObjectTypeId: parseInt(this.rentObjectTypeId),
        parentId: null,
        ownerId: null,
        cleanerId: null,
        name: null,
        code: null,
        url: null,
        street: null,
        zip: null,
        city: null,
        latitude: null,
        longitude: null,
        country: "Deutschland",
        persons: 1,
        rooms: 1,
        bedrooms: 1,
        bathrooms: 1,
        beds: 1,
        floor: null,
        squareMeters: null,
        metersToBeach: null,
        shortDescription: null,
        longDescription: null,
        contractDescription: null,
        activeWebsite: false,
        activeAdmin: false,
        tags: []
      }
    };
  },
  computed: {
    rentObjectType() {
      if (!this.rentObjectTypeId && !this.rentObject) return null;

      return this.$store.getters["rentObjectTypes/getById"](
        this.rentObjectTypeId || this.rentObject.rentObjectTypeId
      );
    },
    rentObject() {
      return this.$store.state.rentObjects.single;
    },
    emailTemplates() {
      return this.$store.state.emailTemplates.all.filter(t => t.uuid.includes('ARRIVAL'));
    }
  },
  methods: {
    async initialSetup() {
      const loadingComponent = this.$buefy.loading.open();
      this.$store.dispatch("emailTemplates/findAll");
      this.$store.dispatch("rentObjectTypes/findAll");

      if (this.$route.name !== "DataRentObjectNew" && this.id) {
        await this.$store.dispatch("rentObjects/findOne", { id: this.id });
        this.formData = {
          ...this.formData,
          ...this.$store.state.rentObjects.single
        };
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      }
      loadingComponent.close();
    },
    createRentObject() {
      this.$store.dispatch("rentObjects/create", this.formData);
    },
    async saveRentObject(m) {
      if (this.id) {
        await this.$store.dispatch("rentObjects/update", {
          id: this.id,
          formData: this.formData
        });
        if (m === "close") {
          this.$router.push({
            name: "DataObjects"
          });
        }
      } else {
        await this.$store.dispatch("rentObjects/create", this.formData);
        this.initialSetup();
      }
    }
  },
  mounted() {
    this.initialSetup();
  }
};
</script>

<style lang="scss" scoped>
.fit-content {
  max-width: fit-content;
}
</style>